export default __webpack_public_path__ + "static/media/23.ada756a8.jpg";